export const FIDO_AUTHENTICATION = 'FIDO AUTHENTICATION';
export const SUCCESSFULL_FIDO_AUTHENTICATION = 'FIDO_AUTHENTICATION_SUCCESS';
export const FIDO_AUTH_FAIL = 'FIDO_AUTHENTICATION_FAILURE';
export const FIDO_REG_SUCCESS = 'FIDO_REGISTRATION_SUCCESS';
export const FIDO_REG_FAIL = 'FIDO_REGISTRATION_FAILURE';
export const REMIND_ME_ACTION = 'REMIND_ME_LATER';
export const SWITCH_TO_PWD_ACTION = 'SWITCH_TO_PASSWORD';
